export default ({ fundNotFound }) => {
  return (
    <div className="mt40 mb30 center">
      {fundNotFound ? (
        <p>
          Sorry the fund has been disabled by the AMC. You can choose other
          funds for investment.
          <div className="background" />
        </p>
      ) : (
        <p>
          We searched everywhere, but the requested URL could not be found. 404!
          <div className="background" />
        </p>
      )}
      <style jsx>{`
        .background {
          height: 200px;
          background-repeat: no-repeat;
          background-size: 900px;
          width: 70%;
          position: relative;
          margin: 0 auto;
          background-position: center -148px;
          background-image: url(https://cleartax.in/img/404_ilsn.svg);
        }
      `}</style>
    </div>
  );
};



// WEBPACK FOOTER //
// ./components/Error404.tsx